<div class="product">
    <div>
        <!-- <div class="offer" *ngIf="menu.offer && !menu.showcomp">
            <img src="assets/images/offer.png" alt="">
        </div> -->
        <div class="info" (click)="showComposition()"
            *ngIf="menu.compositions.elements.length>0 || menu.compositions.families.length>0">
            <img src="assets/images/info.png" alt="info">
        </div>
        <div class="main-img" [ngClass]="{loading:!loadAvatar}">
            <img [src]="menu.avatar|absolutePath:'menus'" [hidden]="!loadAvatar" (load)="loadAvatar=true"
                [alt]="'Livraison '+menu.category+' '+menu.title" [title]="'Livraison '+menu.category+' '+menu.title" />
        </div>
        <div class="compositions back" *ngIf="menu.showcomp">
            <div class="scr">
                <ul>
                    <ng-container *ngIf="menu.compositions.elements.length>0">
                        <li *ngFor="let comp of menu.compositions.elements[0]; let i=index;">
                            <b>{{comp.quantity}}</b> {{comp.name}} <ng-container *ngIf="comp.level">
                                ({{comp.size}})</ng-container>
                        </li>
                    </ng-container>
                    <ng-container *ngFor="let comp of menu.compositions.elements; let i=index;">
                        <ng-container *ngIf="i>0 && comp.length >0">
                            <li>
                                <ng-container *ngFor="let el of comp;let j=index">
                                    <b>{{el.quantity}}</b> {{el.name}} <ng-container *ngIf="el.level">
                                        ({{el.size}})
                                    </ng-container> <b *ngIf="j!=comp.length-1">OU</b>
                                </ng-container>
                            </li>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="menu.compositions.families.length>0">
                        <li *ngFor="let comp of menu.compositions.families[0]; let j=index;">
                            <b>{{comp.quantity}}</b> {{comp.label}} <ng-container *ngIf="comp.level">
                                ({{comp.size}})
                            </ng-container>
                        </li>
                    </ng-container>
                    <ng-container *ngFor="let comp of menu.compositions.families; let i=index;">
                        <ng-container *ngIf="i>0 && comp.length >0">
                            <li>
                                <ng-container *ngFor="let el of comp;let j=index">
                                    <b>{{el.quantity}}</b> {{el.label}} <ng-container *ngIf="el.level">
                                        ({{el.size}})
                                    </ng-container> <b *ngIf="j!=comp.length-1">OU</b>
                                </ng-container>
                            </li>
                        </ng-container>
                    </ng-container>
                </ul>
            </div>
        </div>
    </div>
    <div class="product-body">
        <h2>{{menu.title}}</h2>
        <div class="price">
            <ng-container *ngIf="!menu.offer">
                {{menu.price}} €
            </ng-container>
            <ng-container *ngIf="menu.offer">

            </ng-container>
        </div>
        <p class="alert alert-danger mb-0 text-center radius-0"
            *ngIf="menu.cannotBeOrdered && menu.cannotBeOrderedText">
            {{menu.cannotBeOrderedText}}
        </p>
    </div>
    <div class="product-footer" *ngIf="!menu.cannotBeOrdered">
        <ng-container *ngIf="menu.dispoday">
            <ng-container *ngIf="menu.dispo">
                <div class="row" *ngIf="menu.validPeriod==1">
                    <div class="col-xs-12 no-padding">
                        <button class="add menu btn" (click)="addToBasket()" [disabled]="siteClose">
                            Ajouter au panier
                            <img *ngIf="menu.offer" width="60px" src="assets/images/offer.png" alt="offer">
                            <img *ngIf="!menu.offer" src="assets/images/addBasket.png" alt="panier">
                        </button>
                    </div>
                </div>
                <div class="row" *ngIf="menu.validPeriod==0">
                    <div class="col-xs-12 indisponible">
                        <div class="alert alert-danger text-center">
                            <span *ngIf="menu.menuTime==1">Disponible midi uniquement</span>
                            <span *ngIf="menu.menuTime==3">Disponible soir uniquement</span>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="!menu.dispo">
                <div class="action row">
                    <div class="col-xs-12 indisponible">
                        <div class="alert alert-danger text-center">
                            <span>{{orderName}} NON DISPONIBLE</span>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="!menu.dispoday">
            <div class="action row">
                <div class="col-xs-12 indisponible">
                    <div class="alert alert-danger text-center">
                        <span>NON DISPONIBLE AUJOURD'HUI</span>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>

<ng-template #template>
    <div class="modal-header compositions">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closemodel()">
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">{{menu.label}}</h4>
    </div>
    <div class="modal-body">
        <ul class="list-comp">
            <ng-container *ngIf="compositions[0].length>0">
                <li *ngFor="let comp of compositions[0]; let i=index;">
                    <b *ngIf="comp.quantity>1">{{comp.quantity}}</b> {{comp.name}} {{comp.label}} <ng-container
                        *ngIf="comp.level">
                        ({{comp.size}})</ng-container>
                </li>
            </ng-container>

            <ng-container *ngFor="let i of [1,2,3,4,5,6,7,8,9,10]">
                <ng-container *ngIf="compositions[i].length>0">
                    <li>
                        <ng-container *ngFor="let el of compositions[i];let j=index">
                            <b *ngIf="el.quantity>1">{{el.quantity}}</b> {{el.name}} {{el.label}}<ng-container
                                *ngIf="el.level">
                                ({{el.size}})
                            </ng-container> <b *ngIf="j!=compositions[i].length-1">OU </b>
                        </ng-container>
                    </li>
                </ng-container>
            </ng-container>
        </ul>
    </div>
</ng-template>